import { makeStyles } from '@material-ui/core/styles';

import { COLORS, CSS_CLASS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      width: 55,
      minHeight: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      [`&$expanded, .${CSS_CLASS.scoreHoverableParent}:hover &`]: {
        '& $score': {
          transform: `translateY(${theme.spacing(0)}px)`,
          right: theme.spacing(0.5),
        },

        '& $text': {
          opacity: 1,
          fontSize: theme.typography.pxToRem(12),
          transform: `translateY(${theme.spacing(4)}px)`,
        },
        '& $icon': {
          backgroundColor: COLORS.gray.background,
        },
      },
    },

    expanded: {},
    locked: {},

    score: {
      transform: 'translateY(0px)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.short,
      }),
      right: theme.spacing(0.5),
    },
    text: {
      position: 'absolute',
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: theme.palette.primary.main,
      cursor: 'pointer',

      opacity: 0,
      transform: 'translateY(0px)',
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.short,
      }),
    },
    icon: {
      width: 20,
      height: 20,
      position: 'absolute',
      left: theme.spacing(3.5),
      top: theme.spacing(2),
      backgroundColor: COLORS.neutral.white,
      borderRadius: '100%',
    },
    arrow: {
      fontSize: theme.typography.pxToRem(16),
    },
  }),
  { name: 'ScoreWithDetailsLink' }
);
